var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoGameSegment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26414",
    "data-name": "Group 26414",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.68,
    height: 16.663,
    viewBox: "0 0 16.68 16.663",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46826",
    "data-name": "Path 46826",
    d: "M37.925,5.432a.446.446,0,0,1-.246.4.7.7,0,0,1-.263.053h-.7a.5.5,0,0,1-.316-.123.98.98,0,0,0-.65-.263.948.948,0,0,0,0,1.9.964.964,0,0,0,.65-.246.423.423,0,0,1,.316-.123h.72a.541.541,0,0,1,.228.053.459.459,0,0,1,.246.4v2.932h2.476V10.3A1.814,1.814,0,0,1,40,9.172,1.844,1.844,0,1,1,43.3,10.3v.123h2.476V3.87A1.371,1.371,0,0,0,44.4,2.5H37.925Z",
    transform: "translate(-29.129 -2.5)",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46827",
    "data-name": "Path 46827",
    d: "M2.5,10.384H5.432a.435.435,0,0,1,.369.193.4.4,0,0,1,.07.246v.737a.5.5,0,0,1-.123.316.98.98,0,0,0-.263.65.948.948,0,0,0,1.9,0,.964.964,0,0,0-.246-.65.423.423,0,0,1-.123-.316v-.72a.432.432,0,0,1,.176-.351.486.486,0,0,1,.281-.088H10.4V7.908h-.14a1.814,1.814,0,0,1-1.124.386,1.844,1.844,0,1,1,1.124-3.3h.14V2.5H3.87A1.371,1.371,0,0,0,2.5,3.87Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46828",
    "data-name": "Path 46828",
    d: "M10.4,57.5a.72.72,0,0,1,.018-.193.455.455,0,0,1,.421-.3h.737a.5.5,0,0,1,.316.123.98.98,0,0,0,.65.263.948.948,0,1,0,0-1.9.9.9,0,0,0-.65.263.423.423,0,0,1-.316.123H10.84a.455.455,0,0,1-.421-.3.432.432,0,0,1-.018-.211V52.5H7.908v.14a1.814,1.814,0,0,1,.386,1.124,1.844,1.844,0,1,1-3.3-1.124V52.5H2.5v6.514a1.371,1.371,0,0,0,1.37,1.37h6.514V57.5Z",
    transform: "translate(-2.5 -43.721)",
    fill: "#999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46829",
    "data-name": "Path 46829",
    d: "M60.484,37.908H57.551a.466.466,0,0,1-.4-.246.486.486,0,0,1-.053-.228v-.72a.5.5,0,0,1,.123-.316.98.98,0,0,0,.263-.65.948.948,0,0,0-1.9,0,.964.964,0,0,0,.246.65.423.423,0,0,1,.123.316V37.4a.463.463,0,0,1-.158.4.388.388,0,0,1-.334.105H52.6V40.4h.123a1.814,1.814,0,0,1,1.124-.386,1.844,1.844,0,1,1-1.124,3.3H52.6v2.476h6.514a1.371,1.371,0,0,0,1.37-1.37Z",
    transform: "translate(-43.803 -29.129)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoGameSegment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_gameSegment.eddab31ebcb8511c1f1cd41714533d55.svg";